import React from "react";
import GalleryComponent from "../components/GalleryComponent";

const GalleryScratchPage = () => {
  return <GalleryComponent />;
};

export default GalleryScratchPage;
